const SUPABASE_STORAGE_ORIGIN = 'https://ydicjnhsxtphjhczujhn.supabase.co';
const BRANDED_STORAGE_ORIGIN = 'https://images.useacnesafe.com';

export function brandedProductImageUrl(url) {
  if (!url) return url;

  if (url.startsWith(`${SUPABASE_STORAGE_ORIGIN}/storage/v1/object/public/product-images/`)) {
    return url.replace(SUPABASE_STORAGE_ORIGIN, BRANDED_STORAGE_ORIGIN);
  }

  return url;
}
